module.exports = __webpack_public_path__ + "static/media/companyLogo.4b86c173.svg";